// Define the shape of your data
interface CopyData {
  [key: string]: any; // Or specify exact fields if known
}

export const copyJson = $state<CopyData>({ data: {} });